<script>
    import { createEventDispatcher, onMount, onDestroy, tick } from "svelte";
    import { writable } from "svelte/store";
    import { PowerTable } from "@muonw/powertable";
    import powerTableService from '../../../services/powerTable.js';
    import customService from '../custom/v2-service.js';
    import { notificate } from "../../../services/notification.js";
    import { isJson } from "../../../js/utils.js";
    import tagService from '../../tag/service.js';
    import TagForm from '../../tag/_form.svelte';
    import RemoveVulnerabilityTag from "./remove-vulnerability-tag.svelte";
    import MassiveActionsService from '../../../services/massive-actions.js';
    import VulnerabilityTitleRow from "../../../components/powerTable/vulnerability-title-row.svelte";
    import { locale, format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let data        = [];
    export let ptInstructs = [];
    export let ptOptions   = [];
    export let tags        = [];
    export let showActions = true;

    let reload_edit_modal  = false;
    let selected_rows      = [];
    let lang               = $locale;
    let checkbox;
    let hidden_results_length = 0;
    let is_requesting = false;

    $: (changeTitleLang($locale))

    const parseRows = (pageContent) => {
        pageContent.forEach(row => {
            if(row["priority"]){
                row["priority"] = `<div class="cvss-badge cvss-${row.level}" style="--mwidth: 75px">${parseFloat(row.priority).toPrecision(2)}</div>`
            }
            if(ptInstructs.findIndex(col=>col.key == "title_es") > -1){
                row["title_es"] = {title: row.title, title_es: row.title_es, id: row.id};
            }
            if(ptInstructs.findIndex(col=>col.key == "title") > -1){
                row["title"] = {title: row.title, id: row.id};
            }
            if(ptOptions.uniquePrefix === 'customVulnerabilityTable'){
                row["del"] = `<i class="fa fa-trash vlsk-red" onclick="handleDelete('${row.id}')" style="cursor: pointer;"></i>`
            }

            if(row["tag"]){
                row.tag = powerTableService.parseTagsRow(row.tag, row.__PT_ID__);
            }

            if(row["epss"]){
                row.epss = row.epss < 0.01 ? "< 1%" : `${Math.round((parseFloat(row.epss)*100).toFixed(2))}%`;
            }

            if(!row.epss){
                row.epss = "-"
            }

            if(!row["cvss"]){
                row.cvss = "-";
            }

            if((parseInt(row.open) + parseInt(row.accepted)) <= 0){
                blurRow(row);
            }
            else {
                unblurRow(row);
            }
        });
        deselectAll();
        return pageContent;
    }

    const customSearch = (tData) =>{
        let getData = tableElement.getData(false, ['data','search']);
        let searchObj = getData.search;
        let result = JSON.parse(JSON.stringify(tData));
        let specialInstructs = {};

        let words = searchObj.value.trim().toLowerCase().match(/\S+/g);
        result = result.filter((d) => {
            let unmatchedWords = Object.assign([], words);
            for (let key of Object.keys(d)) {
                if (!specialInstructs.hasOwnProperty(key)) {
                    let searchableString = d?.[key]?.toString()?.toLowerCase();
                    unmatchedWords = unmatchedWords.filter((word) => {
                    if (searchableString?.indexOf(word) > -1) {
                        return false;
                    }
                    return true;
                    });
                }
            }
            return !unmatchedWords.length;
        });
        return {data: result};
    }

    ptOptions.userFunctions= {customSearch: customSearch, customParse: parseRows};

    let tableElement;
    let table_is_expanded = true;
    let tableData = writable(JSON.parse(JSON.stringify(data)));

    for(let vul of data){
        if(!vul.count_by_status){
                vul.open = 0;
                vul.accepted = 0;
                vul.fixed = 0;
                vul.false_positive = 0;
            }
            else {
                vul.open = vul.count_by_status.open;
                vul.accepted = vul.count_by_status.accepted;
                vul.fixed = vul.count_by_status.fixed;
                vul.false_positive = vul.count_by_status.false_positive;
            }
        if(!vul.title) vul.title = "";
        if(!vul.title_es) vul.title_es = vul.title;
    }

    const hideRows = () =>{
        tableData.update(tData=> {
            tData = data.filter(item=>item.count_by_status.open + item.count_by_status.accepted > 0);
            return tData;
        });
        if(ptInstructs.findIndex(col=>col.key == "fixed") > -1 && ptInstructs.findIndex(col=>col.key == "false_positive") > -1){
            hideColumns();
        }

        hidden_results_length = data.length - $tableData.length;
        if(hidden_results_length > 0){
            let stats_container = document.querySelectorAll('[data-name="stats-container"]')[0];
            let element = document.createElement("span");
            element.setAttribute("id", "outOfScopeResults");
            let txt = document.createTextNode("(" + hidden_results_length + $format("list.interface.hidden_results") + ")");
            element.appendChild(txt);
            stats_container.appendChild(element);
        }

        let currentPage = tableElement.getData(true, ['options']).options.currentPage;
        ptOptions.currentPage = currentPage;
        table_is_expanded = false;
    }

    const showRows = async() =>{
        tableData.update(tData => tData = data);
        await tick();
        let currentPage = tableElement.getData(true, ['options']).options.currentPage;
        if(ptInstructs.findIndex(col=>col.key == "fixed") == -1 && ptInstructs.findIndex(col=>col.key == "false_positive") == -1){
            showColumns();
        }

        let element = document.getElementById("outOfScopeResults");
        if(element) element.remove();

        ptOptions.currentPage = currentPage;
        table_is_expanded = true;
    }

    const blurRow = async(row) =>{
        await tick();
        let index = row.__PT_ID__;
        let rowToBlur = document.querySelector(`[data-id='${index}']`);
        if(rowToBlur) rowToBlur.style.opacity = "0.7";
    }

    const unblurRow = async(row) =>{
        await tick();
        let index = row.__PT_ID__;
        let rowToUnblur = document.querySelector(`[data-id='${index}']`);
        if(rowToUnblur) rowToUnblur.style.opacity = "1";
    }

    const changeTitleLang = (new_lang) => {
        lang = new_lang;
        let newInstructs;
        if(new_lang == "en"){
            newInstructs = ptInstructs.filter(col=> col.key != "title_es");
            newInstructs.splice(2, 0, {key: 'title', title: $format("list.columns.title"), filterable: false, parseAs: 'component', dataComponent: VulnerabilityTitleRow })

        }
        if(new_lang == "es"){
            newInstructs = ptInstructs.filter(col=> col.key != "title");
            if(ptInstructs.findIndex(col=> col.key == "title_es") > 0){
                return;
            }
            else {
                newInstructs.splice(2, 0, {key: 'title_es', title: $format("list.columns.title"), filterable: false, parseAs: 'component', dataComponent: VulnerabilityTitleRow })
            }
        }

        ptInstructs = newInstructs;
    }

    const showColumns = () => {
        let pos = ptInstructs.findIndex(col=>col.key === 'accepted');
        ptInstructs.splice(pos + 1, 0, {key: 'fixed', title: $format("list.columns.fixed"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},)
        ptInstructs.splice(pos + 2, 0, {key: 'false_positive', title: $format("list.columns.false_positive"), filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},)
    }

    const hideColumns = () => {
        let pos_fixed = ptInstructs.findIndex(col=>col.key === 'fixed');
        if(pos_fixed > -1){
            ptInstructs.splice(pos_fixed, 1);
        }
        let pos_fp    = ptInstructs.findIndex(col=>col.key === 'false_positive');
        if(pos_fp > -1){
            ptInstructs.splice(pos_fp, 1);
        }
    }

    const handleTableRefresh = () => dispatch("tableRefresh");

    const exportJsonData = (e)=>{
        let currentData = tableElement.getData(false, "matchedData").matchedData;;
        for(let item of currentData){
            delete item.__PT_ID__;
            delete item.__PT_CB__;
            for(let [k,v] of Object.entries(item)){
                if(typeof v === 'string' && isJson(item[k])){
                    item[k] = JSON.parse(v);
                }
            }
        }
        // Download JSON object as a file from browser (https://stackoverflow.com/a/30800715)
        let dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(currentData));
        let downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', 'Vulnerabilidades_vulseek.json');
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }

    const exportToCSV = async ()=> {
        let instructs = ptInstructs;
        let header = [];
        let titles = [];
        const items = tableElement.getData(false, "matchedData").matchedData;;
        for(let item of items){
            if(item.priority){
                item.priority = parseFloat(item.priority).toPrecision(2)
            }
            let tags     = isJson(item.tag) ? JSON.parse(item.tag) : [];
            let tagNames = [];
            for(let tag of tags){
                tagNames.push(tag.name);
            }
            item.tag = tagNames.join(", ");
        }
        const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
        Object.keys(items[0]).forEach((item,i)=>{
            instructs.forEach(col=>{
                if(col.key === item){
                    if(col.title == 'Falso Positivo' || col.title === 'Falso positivo') col.title = col.title.replace(' ', '_');
                    header.push({key: item, value: col.title});
                    titles.push(col.title)
                }
            });
        });
        const csv = [
            titles.join(';'), // header row first
            ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName["key"]], replacer)).join(';'))
        ].join('\r\n');

        let hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'vulnerabilidades_vulseek.csv';
        hiddenElement.click();
    }

    const handleKeydown = (event) => {
        let page = tableElement.getData().options.currentPage;
        if(event.keyCode == 39){
            ptOptions.currentPage = page + 1 ;
        }
        if(event.keyCode == 37){
            if((page - 1) > 0){
                ptOptions.currentPage = page -1 ;
            }
            else {
                return;
            }
        }
        else {
            return;
        }
    }

    let handleDelete = async(id) => {
        let vul = data.find(item=> item.id === id);
        let result = await notificate('confirm_delete', "modal", {massive: false});
        if (!result.isConfirmed) {
            return false;
        }
        customService.del(vul)
            .then(()=>{
                dispatch("tableRefresh", vul);
            })
            .catch(errors=> errors)
        ;
    }

    const selectRow = (event) =>{
        if(!showActions) return;

        reload_edit_modal    = !reload_edit_modal;
        let tData            = tableElement.getData(false,['pageData']);
        let current          = event.detail.data;
        let idx              = selected_rows.findIndex(r=> r.id == current.id);
        selected_rows        = powerTableService.selectRows(selected_rows, current, idx, ptOptions.uniquePrefix, tData.pageData);
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    }

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        // 1. Check if the page is fully selected to determine select vs deselect mode
        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));

        let action = allPageSelected ? "deselect" : "select";

        // 2. Handle selection logic
        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});

                if (!result.isConfirmed && result.dismiss !== "cancel") {
                    return selected_rows;
                }
            }

            let target_elements =
                result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));

            selected_rows = [...selected_rows, ...toAdd];
        } else {
            // Deselect mode: clear everything
            selected_rows = [];
        }

        // 3. Update DOM and action buttons
        powerTableService.toggleActionButtons(selected_rows);

        const domRows = document.querySelectorAll(
            `div[data-prefix='vulnerabilityTable'] table tbody tr`,
        );

        // Map the PT_ID to a fast lookup set of strict strings
        const selectedPtIds = new Set(
            selected_rows.map((r) => String(r.__PT_ID__)),
        );

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) {
                row.classList.add("selected");
            } else {
                row.classList.remove("selected");
            }
        });

        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    }

    const selectAllEventListener = () =>{
        checkbox = document.querySelector(`th[data-key='select']`);
        if(checkbox) checkbox.addEventListener("click", selectAll);
    }

    const rowClicked = async (e) => selectRow(e);

    const openTagModal = () => {
        jQuery("#tag-add-modal").modal('show');
    }

    const closeTagModal = () => {
        jQuery("#tag-add-modal").modal('hide');
        let element = document.getElementById('tagsSelect');
        if(element) element.selectedIndex = 0
    }

    const openTagRemoveModal = () => {
        jQuery("#tag-remove-modal").modal('show');
    }

    const closeRemoveTagModal = () => {
        jQuery("#tag-remove-modal").modal('hide');
        document.getElementById('tagsSelect').selectedIndex = 0;
        dispatch("tableRefresh");
    }

    const handleAddTag = (event) => {
        let tag = {target:{value: event.detail.savedTag.id}}
        handleTagEditFn(tag);
    }

    const handleTagEditFn = async (element) => {
        is_requesting = true;
        let value = element.target.value;
        let requestData = [];

        if(value == 'cancel') return;
        if(value == 'removeTags'){
            if(selected_rows.length > 1) return notificate("select_only_one", "modal");
            return openTagRemoveModal();
        }
        if(value == 'addNewTag'){
            if(selected_rows.length <= 0) return notificate("select_element", "modal");
            return openTagModal();
        }
        else{
            let nodes = selected_rows;
            let ids = new Set(nodes.map(node => node.id));
            const ids_list = [...ids];
            let vulnerabilitiesToEdit = data.filter(vulnerability => ids.has(vulnerability.id));

            if(vulnerabilitiesToEdit.length === 0){
                return notificate('select_element', 'modal');
            }
            for(let vulnerability of vulnerabilitiesToEdit){
                requestData.push({
                    tag_id            : value,
                    target_object_type: "Vulnerability",
                    target_object_id  : vulnerability.id
                });
            }
            let response = await MassiveActionsService.handleTagAssociation(requestData, {});
            if(response.results.length > 0){
                notificate('save_ok', "toast", {data: $format("page.tag.title"), is_massive: true});
            }
        }
        closeTagModal();
        selected_rows = [];
        is_requesting = false;
        dispatch("tableRefresh");
    }

    const showContent = (kind, id)=>{
        let visibleElement = document.getElementById(kind + '-visible-' + id);
        let hiddenElement  = document.getElementById(kind + '-hidden-'  + id);
        visibleElement.classList.remove('is-visible');
        visibleElement.classList.add('is-hidden');
        hiddenElement.classList.remove('is-hidden');
        hiddenElement.classList.add('is-visible');
    }

    const hideContent = (kind, id)=>{
        let visibleElement = document.getElementById(kind + '-visible-' + id);
        let hiddenElement  = document.getElementById(kind + '-hidden-'  + id);
        visibleElement.classList.add('is-visible');
        visibleElement.classList.remove('is-hidden');
        hiddenElement.classList.add('is-hidden');
        hiddenElement.classList.remove('is-visible');
    }

    onMount(async ()=>{
        if(ptInstructs.lengt <= 0){
            ptInstructs = [
                {key: 'priority', title: "Prioridad", filterable: false, parseAs: 'unsafe-html', userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'title_es', title: "Título", filterable: false, parseAs: 'component', dataComponent: VulnerabilityTitleRow },
                {key: 'open', title: "Abierto", filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'accepted', title: 'Aceptado', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'fixed', title: 'Solucionado', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'false_positive', title: 'Falso Positivo', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'cvss', title: 'CVSS', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
                {key: 'epss', title: 'EPSS', filterable: false, userFunctions: {customSort: powerTableService.sortNumbers}},
            ];
        }
        hideRows();
        await tick();
        selectAllEventListener();
        let searchData = tableElement.getData(true, ["matchedData"]);
    });

    onDestroy(()=>{
        if(checkbox) checkbox.removeEventListener("click", selectAll);
    });

    window.handleDelete = handleDelete;
    window.showContent  = showContent;
    window.hideContent  = hideContent;
</script>
<style>
    .btn-refresh {
        margin-top: -20px;
    }
    .btn-refresh:hover {
        background-color: #A59F9F;
    }

    section.content {
        clear: both;
    }

    .overlay-wrapper div {
        display: none;
    }
    .overlay-wrapper div.overlay{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;
    }

</style>
<svelte:window on:keydown={handleKeydown}/>
<div class="card-header">
    {#if !showActions}
        <div class="card-title">{$format("list.columns.vulnerabilities")}</div>
    {/if}
    <div class="float-end">
        {#if $locale != 'en'}
            <button class="btn btn-secondary table-button btn-language btn-xs"  title="{lang == 'es' ? "Ver idioma original" : "Ver idioma seleccionado"}" on:click={()=>changeTitleLang(lang == 'es' ? "en" : "es")}>
                {#key lang}
                    {#if lang == 'es'}
                        <i class="flag-icon flag-icon-ar"></i>
                    {:else}
                        <i class="flag-icon flag-icon-us"></i>
                    {/if}
                {/key}
            </button>
        {/if}

        {#if table_is_expanded}
            <button class="btn btn-secondary table-button btn-compress btn-xs t-compress-vulnerability-btn" tabindex="0" aria-controls="{ptOptions.uniquePrefix}" type="button" title={$format("buttons.hide_fixed_and_fp")} id="vulnerabilityCompressBtn" on:click={hideRows}><i class="fas fa-compress-arrows-alt"></i></button>
        {:else}
            <button class="btn btn-secondary table-button btn-expand btn-xs t-expand-vulnerability-btn" tabindex="0" aria-controls="{ptOptions.uniquePrefix}" type="button" title={$format("buttons.show_fixed_and_fp")} id="vulnerabilityExpandBtn" on:click={showRows}><i class="fas fa-expand-arrows-alt"></i></button>
        {/if}
        {#if showActions}
            <button class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-vulnerability-btn" tabindex="0" aria-controls="{ptOptions.uniquePrefix}" type="button" title={$format("buttons.refresh")} id="vulnerabilityRefreshBtn" on:click={handleTableRefresh}><i class="fa fa-sync-alt"></i></button>
        {/if}
        <button class="btn btn-secondary table-button btn-export btn-xs t-json-vulnerability-btn" tabindex="0" aria-controls="{ptOptions.uniquePrefix}" type="button" title={$format("buttons.json")} id="tagJSONbtn" on:click={exportJsonData}><i class="fab fa-js-square" style="font-size: 18px;"></i></button>
        <button class="btn btn-secondary table-button btn-export btn-xs t-csv-vulnerability-btn" tabindex="0" aria-controls="{ptOptions.uniquePrefix}" type="button" title={$format("buttons.csv")} id="vulnerabilityCSVbtn" on:click={exportToCSV}><i class="fa fa-file-csv" style="font-size: 18px;"></i></button>
        {#if showActions}
            <select disabled id='tagsSelect' name='tagsSelect'  class="form-control btn-disabled" style='height: 28px; clear: left; float: right; max-width: 125px;font-size: 12px; margin-right: 10px;' on:input={(e)=>handleTagEditFn(e)}>
                <option value='cancel'>{$format("buttons.select_tag.select")}</option>
                <option disabled>----------</option>
                <option value='addNewTag'>{$format("buttons.select_tag.add_and_associate")}</option>
                <option disabled>----------</option>
                <option value='removeTags'>{$format("buttons.select_tag.remove")}</option>
                <option disabled>----------</option>
                {#each tags as tag}
                    <option value={tag.id}>{tag.name}</option>
                {/each}
            </select>
        {/if}
    </div>
</div>
<div class="card-body">
    <div class="table-responsive">
        <div class="overlay-wrapper">
            <div class="text-center" class:overlay={is_requesting}><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
        </div>
        <PowerTable ptData={$tableData} {ptInstructs} {ptOptions} on:rowClicked={e=>rowClicked(e)} bind:this={tableElement}>
            <div slot="noResults">
                {$format("results_not_found")}
                {#if hidden_results_length > 0}
                    {@html $format("list.interface.hidden_results_text")}
                {/if}
            </div>
        </PowerTable>
    </div>
</div>




<!-- TAG MODAL -->
<div class="modal fade show" id="tag-add-modal" style="display: none; padding-right: 9px;" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.add")}</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
                <TagForm on:save="{handleAddTag}" on:closeModal={closeTagModal} tag={null}/>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- END TAG MODAL-->


<!-- REMOVE TAG MODAL -->
<div class="modal fade show" id="tag-remove-modal" style="display: none; padding-right: 9px;" aria-modal="true" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.remove")}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    <RemoveVulnerabilityTag vulnerability={selected_rows[0]} on:closeModal={closeRemoveTagModal} on:removeTags={closeRemoveTagModal} />
                {/key}
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- END TAG MODAL-->
